import { render, staticRenderFns } from "./PagePart_edit.vue?vue&type=template&id=58ab29da&scoped=true"
import script from "./PagePart_edit.vue?vue&type=script&lang=js"
export * from "./PagePart_edit.vue?vue&type=script&lang=js"
import style0 from "./PagePart_edit.vue?vue&type=style&index=0&id=58ab29da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab29da",
  null
  
)

export default component.exports